import { render, staticRenderFns } from "./WorkersTable.vue?vue&type=template&id=2b4f1a8f&scoped=true"
import script from "./WorkersTable.vue?vue&type=script&lang=js"
export * from "./WorkersTable.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2b4f1a8f",
  null
  
)

export default component.exports